import { RestService } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import { AppSetDto } from './version-info.model';

@Injectable({
  providedIn: 'root',
})
export class VersionInfoService {
  apiName = 'Default';
  constructor(private restService: RestService) {}

  getAppSet = () =>
    this.restService.request<void, AppSetDto>(
      {
        method: 'GET',
        url: `/api/app/version`,
      },
      { apiName: this.apiName },
    );
}
